import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import { formSelectorsFactory } from 'state/secondaryMarket/shared/form/form.selector';
import type { AppState } from 'state/state.model';

export const formInputSelectorsFactory = <S>(stateType: Exclude<SecondaryOrderStatePath, 'cpOrder'>, selectors: S) => {
  const select = (state: AppState, tabId: string) => state.secondaryMarket[stateType].form.input[tabId];
  return {
    getFormChanges: (state: AppState, tabId: string) => select(state, tabId)?.changes ?? [],
    ...formSelectorsFactory(stateType, 'input', selectors),
  };
};
